import { Link } from "react-router-dom";
import { ArrowRight, Newspaper } from "lucide-react";
import { mediaUrl } from "../lib/api";
import { fmtDate } from "../lib/dates";

export const ActuCard = ({ a }) => (
  <Link to={`/actualites/${a.slug}`} data-testid={`actu-card-${a.slug}`} className={`group bg-white border border-ink/10 h-full flex flex-col ${a.featured ? "lg:col-span-2" : ""}`}>
    <div className={`overflow-hidden bg-ink grain grid place-items-center ${a.featured ? "aspect-[16/8]" : "aspect-[16/10]"}`}>
      {a.image_url ? (
        <img src={mediaUrl(a.image_url)} alt={a.image_alt} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
      ) : (
        <Newspaper className="text-white/25" size={40} />
      )}
    </div>
    <div className="p-6 flex flex-col gap-3 flex-1">
      <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-ink/50">{a.featured ? "À la une · " : ""}{fmtDate(a.published_at)}</span>
      <h3 className={`font-display font-extrabold leading-tight ${a.featured ? "text-2xl lg:text-3xl" : "text-xl"}`}>{a.title}</h3>
      {a.summary && <p className="text-sm text-ink/65 leading-relaxed">{a.summary}</p>}
      <span className="mt-auto pt-4 border-t border-ink/10 text-sm font-semibold flex items-center gap-2">
        Lire la suite <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
      </span>
    </div>
  </Link>
);
